//http://localhost:2205/admin
//http://localhost:2205/admin/upload

export const END_POINT = "https://api.morprawate.com/admin";
